import { gql } from "common/graphqlAdapter";
import { LearningFragment } from "@devforce/trailhead-client-gql";
import {
  fromLearning,
  fromCommunity,
  fromJob,
  fromUnified,
} from "common/contentSummary";

class PersonalizedLearningQuery {
  options = null;
  useFetch = true;
  recommendationAnalyticsMetadata = {};
  interActionStudioMetadata = {};
  constructor(options) {
    this.options = options;
  }
  query = gql`
    ${LearningFragment}
    query ThexternalPersonalizedLearning(
      $campaignName: String!
      $userContext: RecommendationUserContext!
      $fallbackItems: [RecommendationFallbackInput!]
      $allowEnglishFallbacks: Boolean!
    ) {
      visitorRecommendations(
        campaignName: $campaignName
        userContext: $userContext
        fallbackItems: $fallbackItems
        allowEnglishFallbacks: $allowEnglishFallbacks
      ) {
        recommendations {
          contentItem {
            ...Learning
          }
        }
        interactionStudioMetadata {
          campaignId
          campaignName
          experienceId
          experienceName
          googleClientId
          itemType
          userGroup
        }
        recommendationAnalyticsMetadata {
          englishFallbacksRendered
          fallbackItemsRendered {
            name
            type
          }
        }
      }
    }
  `;
  getQueryOptions() {
    const { campaignName, userContext, fallbackItems, allowEnglishFallbacks } =
      this.options;
    return {
      query: this.query,
      variables: {
        campaignName,
        userContext,
        fallbackItems,
        allowEnglishFallbacks,
      },
    };
  }
  getCollectionItems(result) {
    const edges = result.data.visitorRecommendations.recommendations ?? [];
    this.recommendationAnalyticsMetadata =
      result.data.visitorRecommendations.recommendationAnalyticsMetadata;
    this.interActionStudioMetadata =
      result.data.visitorRecommendations.interactionStudioMetadata;
    return edges
      .map((edge) => edge.contentItem)
      .map((learning) => getCollectionItem(learning));
  }
}
const DEFAULT_LIMIT = 3;
function createConfig(config, defaultConfig) {
  return {
    ...defaultConfig,
    ...config,
    card: {
      layout: "stack",
      variant: "default",
      ...defaultConfig?.card,
      ...config?.card,
    },
    item: {
      variant: "brick",
      ...defaultConfig?.item,
      ...config?.item,
    },
    limit: config?.limit ?? defaultConfig?.limit ?? DEFAULT_LIMIT,
    state: {
      ...defaultConfig?.state,
      ...config?.state,
      loading: {
        stencilCount: config?.limit ?? defaultConfig?.limit ?? DEFAULT_LIMIT,
        ...defaultConfig?.state?.loading,
        ...config?.state?.loading,
        stencilVariant:
          config?.state?.loading?.stencilVariant ??
          config?.item?.variant ??
          "brick",
        preserveLayout: config?.state?.loading?.preserveLayout,
      },
    },
  };
}
function getCollectionItem(learning, user, eventData) {
  return {
    action: {
      learning,
      user,
      eventData,
    },
    summary: fromLearning(learning),
  };
}
function getCommunityCollectionItem(communityItem) {
  return {
    summary: fromCommunity(communityItem),
  };
}
function getJobCollectionItem(job) {
  return {
    summary: fromJob(job),
  };
}
function getUnifiedCollectionItem(unified) {
  const summary = fromUnified(unified);
  if (summary == null) return null;
  return {
    action: undefined,
    summary,
  };
}

export {
  DEFAULT_LIMIT,
  PersonalizedLearningQuery,
  createConfig,
  getCollectionItem,
  getCommunityCollectionItem,
  getJobCollectionItem,
  getUnifiedCollectionItem,
};
